import { BrowserRouter, Routes, Route } from "react-router-dom";
import NoPage404 from "./pages/NoPage404";
import Dashboard from "./pages/Dashboard";
import ImportExportEmails from "./pages/ImportExportEmails";
import CreateSendEmail from "./pages/CreateSendEmail";
import EmailTemplates from "./pages/EmailTemplates";
import CronJobs from "./pages/CronJobs";
import UploadAndValidateCSV from "./pages/UploadAndValidateCSV";



function CustomRoute() {
    return (
        <>
            <BrowserRouter>
                <Routes>
                    <Route path="*" element={<NoPage404 />} />
                    <Route index element={<Dashboard />} />
                    <Route path="/importexport" element={<ImportExportEmails />} />
                    <Route path="/createsend" element={<CreateSendEmail />} />
                    <Route path="/emailtemplates" element={<EmailTemplates />} />
                    <Route path="/cronjobs" element={<CronJobs />} /> 
                    <Route path="/uploadvalidate" element={<UploadAndValidateCSV />} />
                </Routes>
            </BrowserRouter>
        </>
    );
}

export default CustomRoute;